import { render, staticRenderFns } from "./UserAccountPurchases.vue?vue&type=template&id=01f97606&"
import script from "./UserAccountPurchases.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports